import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CheckSvg = _resolveComponent("CheckSvg")!
  const _component_XSvg = _resolveComponent("XSvg")!

  return (_ctx.result)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["result-ok", _ctx.rightClassName])
      }, [
        _createVNode(_component_CheckSvg, { scale: _ctx.scale }, null, 8, ["scale"])
      ], 2))
    : (_openBlock(), _createElementBlock("div", {
        key: 1,
        class: _normalizeClass(["result-wrong", _ctx.wrongClassName])
      }, [
        _createVNode(_component_XSvg, { scale: _ctx.scale }, null, 8, ["scale"])
      ], 2))
}